import { render } from "./product-price-groups.vue?vue&type=template&id=19b8e8fb"
import script from "./product-price-groups.vue?vue&type=script&lang=js"
export * from "./product-price-groups.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__